export const ID_VERIFICATION_IFRAME_HEIGHT = 750;
export const ID_VERIFICATION_IFRAME_HEIGHT_MOBILE = 500;
